export enum EducationProgressTypeEnum {
    SCALE = 'Scale',
    FACT = 'Fact'
}